//using pallette from image https://www.canva.com/colors/color-palette-generator/
// Green Pea
// #1f6261
// Cardinal
// #c42126
// Deco
// #d7d38c
// Kimberly
// #8272a6

//from imagecolorpicker.com
// #1d5e5e
// #d7d38c
// #c31c24
// #4bb485
// #e1683b
// #8070a6

// const COLORS = {
//   color1: "#0a959e",
//   color2: "#324b4d",
//   color3: "#94b0b3",
//   color4: "#b3795a",
//   color5: "#7b482c",
// };

// https://www.canva.com/learn/website-color-schemes/ #9
// #94618E // grape
// #49274A // eggplant
// #F4DECB // sand
// #F8EEE7 // sand

// https://www.canva.com/learn/website-color-schemes/ #10
// #4484CE // cerulean
// #D9D9D9 // aluminum
// #F9CF00 // light
// #F19F4D // tangerine

// https://www.canva.com/learn/website-color-schemes/ #12
// #266DA8 // summer sky
// #CD5360 // warm peach
// #B37D4E // field
// #438496 // breeze

// https://www.canva.com/learn/website-color-schemes/ #16
// #687A8F // blueberry
// #F7882F // apricot
// #F7C331 // citrus
// #DCC7AA // apple core

// https://www.canva.com/learn/website-color-schemes/ #48
// #A7D2CB // clean
// #F2D388 // butter
// #C98474 // salmon
// #874C62 // eggplant

const colors = {
  dark: "#687A8F",
  dark2: "#F7882F",
  medium: "#F7C331",
  light2: "#DCC7AA",
  light: "#E8EAF6",
};
export default colors;
